/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentSasUrlDto } from '../../models/document-sas-url-dto';

export interface CreateEmergencyAlertPlanDocx$Params {

/**
 * customer id
 */
  customerId: number;
}

export function createEmergencyAlertPlanDocx(http: HttpClient, rootUrl: string, params: CreateEmergencyAlertPlanDocx$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentSasUrlDto>> {
  const rb = new RequestBuilder(rootUrl, createEmergencyAlertPlanDocx.PATH, 'post');
  if (params) {
    rb.path('customerId', params.customerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DocumentSasUrlDto>;
    })
  );
}

createEmergencyAlertPlanDocx.PATH = '/customers/{customerId}/emergency-alarm-plan/docx';
